import React from 'react'

export const ArrowDown = props => (
  <svg
    width='32'
    height='33'
    viewBox='0 0 32 33'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g>
      <path
        id='Vector (Stroke)'
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M16.0002 3.11719C16.7365 3.11719 17.3335 3.71414 17.3335 4.45052V25.2316L24.3907 18.1744C24.9114 17.6537 25.7556 17.6537 26.2763 18.1744C26.797 18.6951 26.797 19.5393 26.2763 20.06L16.943 29.3933C16.4223 29.914 15.5781 29.914 15.0574 29.3933L5.72402 20.06C5.20332 19.5393 5.20332 18.6951 5.72402 18.1744C6.24472 17.6537 7.08894 17.6537 7.60964 18.1744L14.6668 25.2316V4.45052C14.6668 3.71414 15.2638 3.11719 16.0002 3.11719Z'
      />
    </g>
  </svg>
)
